module.exports = __webpack_public_path__ + "assets/fonts/iconfont.c24064c6.ttf";